

const inkNeedMoreForm = {
  template: require('./need-more-form.template.html')
};

angular
  .module('inkfinder')
  .component('inkNeedMoreForm', inkNeedMoreForm);



// WEBPACK FOOTER //
// ./components/appointments/add/need-more-form/need-more-form.component.js